import { render, staticRenderFns } from "./BandeauComm.vue?vue&type=template&id=05f295e8&scoped=true"
import script from "./BandeauComm.vue?vue&type=script&lang=js"
export * from "./BandeauComm.vue?vue&type=script&lang=js"
import style0 from "./BandeauComm.vue?vue&type=style&index=0&id=05f295e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f295e8",
  null
  
)

export default component.exports